import TC from '../../TC';
import Consts from '../Consts';
import Control from '../Control';

TC.Consts = Consts;
TC.control = TC.control || {};
TC.Control = Control;

TC.control.Attribution = function () {
    const self = this;

    TC.Control.apply(self, arguments);

    self.apiAttribution = '';
    self.mainDataAttribution = null;
    self.dataAttributions = [];
    if (self.options.dataAttributions) {
        self.dataAttributions = self.options.dataAttributions instanceof Array ? self.options.dataAttributions : [self.options.dataAttributions];
    }
};

TC.inherit(TC.control.Attribution, TC.Control);

(function () {
    var ctlProto = TC.control.Attribution.prototype;

    ctlProto.CLASS = 'tc-ctl-attrib';

    ctlProto.template = {"1":function(container,depth0,helpers,partials,data) {    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return " - "    + container.escapeExpression(lookupProperty(helpers,"i18n").call(alias1,"data",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":3,"column":23},"end":{"line":3,"column":38}}}))    + ":\r\n"    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"mainData") : depth0)) != null ? lookupProperty(stack1,"site") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":10,"column":15}}})) != null ? stack1 : "");},"2":function(container,depth0,helpers,partials,data) {    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "            <span> <a href=\""    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"mainData") : depth0)) != null ? lookupProperty(stack1,"site") : stack1), depth0))    + "\" target=\"_blank\">"    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"mainData") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))    + "</a></span>\r\n";},"4":function(container,depth0,helpers,partials,data) {    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"mainData") : depth0)) != null ? lookupProperty(stack1,"name") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":12},"end":{"line":9,"column":19}}})) != null ? stack1 : "");},"5":function(container,depth0,helpers,partials,data) {    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "                <span> "    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"mainData") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))    + "</span>\r\n";},"7":function(container,depth0,helpers,partials,data) {    var lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return " - <span class=\"tc-ctl-attrib-cmd\">"    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"others",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":12,"column":56},"end":{"line":12,"column":73}}}))    + "...</span>";},"9":function(container,depth0,helpers,partials,data) {    return " tc-collapsed";},"11":function(container,depth0,helpers,partials,data) {    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return ((stack1 = lookupProperty(helpers,"unless").call(alias1,(data && lookupProperty(data,"first")),{"name":"unless","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":20},"end":{"line":14,"column":51}}})) != null ? stack1 : "")    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"site") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.program(16, data, 0),"data":data,"loc":{"start":{"line":14,"column":51},"end":{"line":14,"column":159}}})) != null ? stack1 : "");},"12":function(container,depth0,helpers,partials,data) {    return ", ";},"14":function(container,depth0,helpers,partials,data) {    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "<span><a href=\""    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"site") : depth0), depth0))    + "\" target=\"_blank\">"    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))    + "</a></span>";},"16":function(container,depth0,helpers,partials,data) {    var lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "<span>"    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))    + "</span>";},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {          return parent[propertyName];        }        return undefined    };  return "<div>\r\n    <span>"    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"api") : depth0), depth0)) != null ? stack1 : "")    + "</span>\r\n    "    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"mainData") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")    + "    "    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"otherData") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":12,"column":90}}})) != null ? stack1 : "")    + "\r\n    <div class=\"tc-ctl-attrib-other"    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isCollapsed") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":35},"end":{"line":13,"column":74}}})) != null ? stack1 : "")    + "\">\r\n	"    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"otherData") : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":1},"end":{"line":14,"column":168}}})) != null ? stack1 : "")    + "\r\n    </div>\r\n</div>";},"useData":true}

    ctlProto.register = function (map) {
        const self = this;
        const result = TC.Control.prototype.register.call(self, map);

        self.apiAttribution = self.map.options.attribution || self.apiAttribution;

        var addData = function (obj) {
            if (obj) {
                // TODO: sanitizer
                var attr = obj.getAttribution();
                if (attr) {
                    if (/IDENA/.test(attr.name) || /Tracasa Instrumental/.test(attr.name)) {
                        self.mainDataAttribution = {
                            name: 'IDENA',
                            site: 'https://idena.navarra.es/'
                        };
                    }
                    else {
                        var textExists = false;
                        for (var i = 0; i < self.dataAttributions.length; i++) {
                            if (attr.name === self.dataAttributions[i].name) {
                                textExists = true;
                                break;
                            }
                        }
                        if (!textExists) {
                            self.dataAttributions.push(attr);
                        }
                    }
                }
            }
        };

        var removeData = function (obj) {
            if (obj) {

                var checkRemoveData = function () {
                    if (obj.map.workLayers.length > 0) {
                        const wlArr = obj.map.workLayers
                            .slice()
                            .reverse();
                        for (var i = 0; i < wlArr.length; i++) {
                            const wl = wlArr[i];
                            if (wl.url == obj.url && wl.getVisibility()) {
                                return false;
                            }
                        }

                        return true;
                    }

                    return true;
                };

                if (obj instanceof TC.Layer ? checkRemoveData() : true) {
                    // TODO: sanitizer
                    var attr = obj.getAttribution();

                    if (attr) {
                        var index = self.dataAttributions.reduce(function (prev, cur, idx) {
                            if (cur.name === attr.name) {
                                return idx;
                            }
                            return prev;
                        }, -1);

                        const checkIsSameAttribution = function (toCheckName) {
                            return (/IDENA/.test(attr.name) || /Tracasa Instrumental/.test(attr.name)) &&
                                (/IDENA/.test(toCheckName) || /Tracasa Instrumental/.test(toCheckName)) ||
                                    attr.name === toCheckName;
                        };

                        // 07/10/2020 Validamos contra el mapa de fondo antes de cambiar de mapa de fondo así que no se borran cuando deberían.
                        // Validamos que la capa a borrar no sea la de fondo actual
                        // Validamos si las atribuciones a borrar son también del mapa base
                        if (self.map.baseLayer && self.map.baseLayer.wrap.getAttribution() && checkIsSameAttribution(self.map.baseLayer.wrap.getAttribution().name) && 
                            obj.parent.id !== self.map.baseLayer.id) {
                            return;
                        } else {
                            // Validamos si las atribuciones a borrar son también de alguna de las capas raster cargadas
                            if (self.map.workLayers.filter(function (layer) {
                                return layer.type === TC.Consts.layerType.WMS || layer.type === TC.Consts.layerType.WMTS;
                            }).some(function (layer) {
                                var workLayerAttribution = layer.wrap.getAttribution();
                                return workLayerAttribution && checkIsSameAttribution(workLayerAttribution.name);
                            })) {
                                return;
                            }
                        }

                        if (index > -1) {
                            self.dataAttributions.splice(index, 1);
                        } else if (/IDENA/.test(attr.name) || /Tracasa Instrumental/.test(attr.name)) {
                            self.mainDataAttribution = null;
                        }
                    }
                }
            }
        };
        //URI: Si las atribuciones están vacias evito hace una llamada al renderizado del control ya que lo obtendría sin datos.
        //self.render();

        map.loaded(function () {
            if (map.baseLayer.wrap.getAttribution) {
                addData(map.baseLayer.wrap);
                self.render();
            }
        });

        map.on(TC.Consts.event.LAYERADD, function (e) {
            const layer = e.layer;
            if (!layer.isBase && layer.wrap.getAttribution && layer.wrap.getAttribution()) {
                addData(layer.wrap);
                self.render();
            }
        });

        map.on(TC.Consts.event.BEFOREBASELAYERCHANGE + " " + TC.Consts.event.OVERVIEWBASELAYERCHANGE, function (e) {
            const type = e.type;
            const newLayer = e.newLayer;
            const oldLayer = e.oldLayer;
            if (TC.Consts.event.OVERVIEWBASELAYERCHANGE.indexOf(type) > -1) {
                self.ignoreLayer = newLayer;
            }

            if (oldLayer && oldLayer.wrap.getAttribution) {
                removeData(oldLayer.wrap);
            }

            if (newLayer && newLayer.wrap.getAttribution) {
                addData(newLayer.wrap);
            }

            self.render();
        });

        map.on(TC.Consts.event.LAYERREMOVE, function (e) {
            const layer = e.layer;
            if (layer.wrap.getAttribution) {
                removeData(layer.wrap);
                self.render();
            }
        });

        map.on(TC.Consts.event.TERRAINPROVIDERADD, function (e) {
            const terrainProvider = e.terrainProvider;
            if (terrainProvider.getAttribution) {
                addData(terrainProvider);
                self.render();
            }
        });

        map.on(TC.Consts.event.TERRAINPROVIDERREMOVE, function (e) {
            const terrainProvider = e.terrainProvider;
            if (terrainProvider.getAttribution) {
                removeData(terrainProvider);
                self.render();
            }
        });

        map.on(TC.Consts.event.LAYERVISIBILITY, function (e) {
            const layer = e.layer;
            if (self.ignoreLayer === layer) {
                return;
            }

            if (layer.wrap.getAttribution) {
                if (layer.getVisibility()) {
                    addData(layer.wrap);
                } else {
                    removeData(layer.wrap);
                }
                self.render();
            }
        });

        return result;
    };

    ctlProto.render = function (callback) {
        const self = this;        

        return self._set1stRenderPromise(self.renderData({
            api: typeof self.apiAttribution === 'function' ? self.apiAttribution.apply(self) : self.getLocaleString(self.apiAttribution),
            mainData: self.mainDataAttribution,
            otherData: self.dataAttributions,
            isCollapsed: self.div.querySelector('.' + self.CLASS + '-other') ? self.div.querySelector('.' + self.CLASS + '-other').classList.contains(TC.Consts.classes.COLLAPSED) : true
        }, function () {
            const cmd = self.div.querySelector('.' + self.CLASS + '-cmd');
            cmd && cmd.addEventListener(TC.Consts.event.CLICK, function () {
                self.toggleOtherAttributions();
            }, { passive: true });

            if (typeof callback === 'function') {
                callback();
            }
        }));
    };

    ctlProto.toggleOtherAttributions = function () {
        const self = this;
        const other = self.div.querySelector('.' + self.CLASS + '-other');
        other.classList.toggle(TC.Consts.classes.COLLAPSED);
    };
})();

const Attribution = TC.control.Attribution;
export default Attribution;